import React from "react";
import Spinner from "../../atoms/Spinner/index";
import Typography from "@material-ui/core/Typography";

export default class Thumb extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      naturalHeight: 0,
      naturalWidth: 0
    };

    // This binding is necessary to make `this` work in the callback

    this.imageLoaded = this.imageLoaded.bind(this);
  }
  imageLoaded(e) {
    this.setState({
      naturalHeight: e.target.naturalHeight,
      naturalWidth: e.target.naturalWidth
    });
  }

  renderImageQualityError() {
    const { naturalHeight, naturalWidth } = this.state;
    if (
      (naturalHeight !== 0) & (naturalHeight < 500) ||
      (naturalWidth !== 0) & (naturalWidth < 500)
    ) {
      // minmum 200 Dpi required, Size ID Card 85x50mm
      return (
        <Typography
          style={{
            backgroundColor: "red",
            color: "white",
            fontWeight: "bold",
            position: "absolut",
            bottom: "0",
            padding: "5px"
          }}
        >{`Image Quality (${naturalWidth}x${naturalHeight}px) too low! Please upload a better image with more than 500px per dimension. `}</Typography>
      );
    }
    return null;
  }

  render() {
    const { image, loading, placeholder, name } = this.props;

    if (loading) {
      return (
        <div style={{ height: "220px", width: "100%" }}>
          <Spinner />
        </div>
      );
    }

    if (!image) {
      return placeholder ? (
        <img
          alt=""
          src={placeholder}
          style={{ maxHeight: "100%", width: "auto", maxWith: "100%" }}
        />
      ) : null;
    }

    return (
      <div style={{ position: "relative" }}>
        <img
          src={image}
          alt={name}
          onLoad={this.imageLoaded}
          style={{ maxHeight: "220px", height: "auto", maxWidth: "100%" }}
        />
        {this.renderImageQualityError()}
      </div>
    );
  }
}
